class ValueDescription {
  static toName = (id: string): string => {
    switch(id) {
      case 'single': return "Single value";
      case 'mean': return "Mean";
      case 'median': return "Median";
      case 'mode': return "Mode";
      default: return "Unknown result value description";
    }
  }

  static getList = (): string[] => {
    return [
      'single',
      'mean',
      'median',
      'mode'
    ];
  }
}

export { ValueDescription }